import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { RemovableEvents } from '../types';

export class GzRemovableWebComponent extends LitElement {
  @property({ type: Boolean, reflect: true })
  disabled = false;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <slot></slot>
      <gz-icon-button
        @click="${this.handleRemoveInputButtonClick}"
        class="remove-button"
        icon="ds-icon-cancel"
        fontSize="24"
        buttonType="square"
        buttonColor="secondary"
      ></gz-icon-button>
    `;
  }

  private handleRemoveInputButtonClick() {
    const event = new CustomEvent(RemovableEvents.SHOULD_REMOVE_ITEM, {
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }
}
